import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/api/api.service';
import { endpoints } from 'src/app/core/config/endpoints';
import { LinecardElementComment } from 'src/app/core/models/linecard.model';

@Injectable({
	providedIn: 'root'
})
export class LinecardService {

	constructor(
		private api: ApiService,
	) { }

	addChangeComment(comment: LinecardElementComment) {
		this.api.post(endpoints.linecard.comment, comment);
	}
}
